export default "__VITE_ASSET__CnVVNM1V__"